module.exports = __webpack_public_path__ + "static/media/hezuohuoban.e0bd0143.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/detail/images/hezuohuoban.png
// module id = 748
// module chunks = 0